import * as React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@lightspeed/flame/Modal';
import { Flex } from '@lightspeed/flame/Core';
import { Button } from '@lightspeed/flame/Button';
import { setCfdModal } from 'pages/views/devices/utils/helper';
import { ModalHeaderContent } from './ModalHeaderContent';
import Options from '../Options';
import { OPTIONS } from '../Options/types';

interface CfdSettingsModalProps {
  isModalOpen: boolean;
}

const CfdSettingsModal: React.FC<CfdSettingsModalProps> = ({ isModalOpen }) => {
  const [showDeviceConnection, setShowDeviceConnection] = React.useState(false);
  const onClose = () => setCfdModal(undefined);

  return (
    <Modal isOpen={isModalOpen} onRequestClose={onClose} css={{ width: '600px' }}>
      <ModalHeader css={{ alignItems: 'unset' }}>
        <ModalHeaderContent
          handleClick={() => setShowDeviceConnection(false)}
          showDeviceConnection={showDeviceConnection}
        />
      </ModalHeader>
      <ModalBody scroll style={{ padding: 0 }}>
        <Options
          options={[
            OPTIONS.IS_UNTAXED_ITEM_NOTE_VISIBLE,
            OPTIONS.IS_CUSTOMER_NAME_VISIBLE,
            OPTIONS.IS_CONNECTION_STATUS_VISIBLE,
            OPTIONS.IS_LOGO_VISIBLE,
            OPTIONS.IS_DEBUG_MODE,
          ]}
        />
      </ModalBody>
      <ModalFooter>
        <Flex justifyContent="flex-end">
          <Button onClick={onClose}>Close</Button>
        </Flex>
      </ModalFooter>
    </Modal>
  );
};

export { CfdSettingsModal };
